<template>
  <tr>
    <td>
      <div class="segments">
        <template v-if="item.segments.length">
          <div v-for="(segment, index) in item.segments" :key="index">{{ segment.name }}</div>
        </template>
        <span v-else>-</span>
      </div>
    </td>
    <td>
      {{ item.name }}
    </td>
    <td>
      <div
        class="buttons"
        v-if="
          $userCheckAccess({
            abilities: 'edit_project_types',
          })
        "
      >
        <ProjectTypeModal :id="item.id" />
        <DeleteModal
          :item="item"
          :text="
            localStorage.translations.pages['setting-project_type']['dialog-delete'][
              'udalit-tip-proekta'
            ] +
            ' ' +
            item.name
          "
        />
      </div>
    </td>
  </tr>
</template>

<script>
import ProjectTypeModal from 'components/setting/projectType/ProjectTypeModal'
import DeleteModal from 'components/DeleteModal'

export default {
  name: 'WorkTypeTableItem',
  components: { ProjectTypeModal, DeleteModal },
  props: ['item'],
}
</script>
